// extracted by mini-css-extract-plugin
export default {"container":"select_container__T8obI","select":"select_select__jhuCk","error":"select_error__V-939","asterisk":"select_asterisk__VKg7g"};